<template>
<!-- 分页组件 -->
    <div class="con">
        <el-pagination
                @size-change="handleSizeChanges"
                @current-change="handleCurrentChanges"
                :current-page="offset"
                :page-sizes="[10,25,50,100]"
                :page-size="limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
        </el-pagination>
    </div>
</template>

<script>
// 分页组件 --接收三个参数 切换分页与切换每页数量触发父组件搜索方法
    export default {
        props: {
            //分页总数
            total: {
                type: Number,
                default: 0
            },
            //当前页数量
            limit: {
                type: Number,
                default: 10
            },
            //当前页
            offset: {
                type: Number,
                default: 1
            }
        },
        data() {
            return {
                changetimer:null
            }
        },
        methods: {
            handleSizeChanges(val) {
                    this.$emit('SizeChanges', val)
            },
            handleCurrentChanges(val) {
                if(this.changetimer!==null){
                    clearTimeout(this.changetimer)
                }
                this.changetimer=setTimeout(()=>{
                    this.$emit('CurrentChanges', val)
                },500)
            }
        }
    }
</script>

<style scoped>
    .con {
        text-align: center;
        margin-top: 0.4rem;
    }
</style>
